// 默认版本信息配置
import { TVersion } from './tversion'

// 版本信息常量
export const VERSION_NAME = TVersion.VERSION_NAME
export const GIT_COMMIT = TVersion.GIT_COMMIT
export const BRANCH_NAME = TVersion.BRANCH_NAME
export const BUILD_TIME = TVersion.BUILD_TIME

// 打印版本信息的函数
export const printVersionInfo = () => {
  console.info('应用版本信息:')
  console.info(`versionName: ${VERSION_NAME}`)
  console.info(`gitCommit: ${GIT_COMMIT}`)
  console.info(`branchName: ${BRANCH_NAME}`)
  console.info(`buildTime: ${BUILD_TIME}`)
  console.info('─'.repeat(50))
}
